<mat-card>
    <h4 class="text-center">Revenue vs Bookings</h4>
    <div style="height: 350px">
        <canvas id="ppSpend"></canvas>
    </div>
</mat-card>
